<app-title-bar [title]='"Importar Capa"' [icon]="'library_add'"></app-title-bar>
<div name="content" class="styleContent">
  <p style="text-align: center;">
    <b>SELECCIONA UN ARCHIVO COMPATIBLE:</b>
  </p>
  <ul>
    <li>SHAPEFILE (COMPRIMIDO EN .ZIP)</li>
    <li>GPX</li>
    <li>GEO JSON</li>
    <li>CSV</li>
  </ul>
  <form id="uploadForm" class="uploadForm" (change)="uploadFile($event)">
    <input type="file" name="file" id="inFile" class="input-custom">
    <label for="inFile" class="label-input">
      BUSCAR
    </label>
  </form>
  <div id="status-file" class="styleStatus">
    <p id="upload-status" class="upload-status">{{uploadStatus}}</p>
  </div>
</div>